// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"brands-block_wrapper__YBrt8","title":"brands-block_title__ph1zG","intro":"brands-block_intro__BkLjK","link":"brands-block_link__6DnXD","grid":"brands-block_grid__Hpltp"};